import type {
  InsertDepartmentTypeWithGroupNameMutation,
  InsertDepartmentTypeWithGroupNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDepartmentTypeWithGroupNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertDepartmentTypeWithGroupName = createMutationHook({
  name: 'insertDepartmentTypeWithGroupName',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.insertTypeWithGroupName.mutationOptions({
      onSuccess,
    }),
  mapInput: (
    variables: InsertDepartmentTypeWithGroupNameMutationVariables
  ): {
    Name: string;
    Description?: string | null;
    DepartmentGroupName?: string | null;
  } => {
    if (!variables.Name) {
      throw new Error('Name is required');
    }

    return {
      Name: variables.Name,
      Description: variables.Description,
      DepartmentGroupName: variables.DepartmentGroupName,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.department.allTypes.queryKey(),
    trpc.frontend.department.departmentTypeGroups.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
  }): InsertDepartmentTypeWithGroupNameMutation => ({
    insert_department_type_one: {
      __typename: 'department_type',
      DepartmentTypeId: result.Id,
    },
  }),
  graphqlDocument: InsertDepartmentTypeWithGroupNameDocument,
  graphqlVariables: (
    variables: InsertDepartmentTypeWithGroupNameMutationVariables
  ) => ({ ...variables }),
  evictFields: ['department_type', 'department_type_group'],
});
